<template>
    <div class="activity">
        <ul>
            <li class="item m-b-10" v-for="(item, index) in dataList" :key="index" @click="viewPage(item.activityId)">
                <img class="imgSize" :src="item.targetName" alt="">
            </li>
        </ul>
    </div>
</template>
<script>
import { listActivity } from '@/api/index';
export default {
    data(){
        return{
            dataList:[]
        }
    },
    created(){
        this.getData();
    },
    methods:{
        getData(){
            listActivity().then(res => {
                res.data.forEach(item => {
                    item.targetName = `https://fanhuayiju.oss-cn-beijing.aliyuncs.com/${item.targetName}`;
                });
                this.dataList = res.data;
            }).catch( error => {
                console.log('获取活动列表 views/activity/index.vue')
            })
        },
        viewPage(item){
            this.$router.push({path:'/activeInfo',query:{activeId:item }});
        }
    }
}
</script>
<style lang="scss" scoped>
.activity{
    width: 100%;
    background: #f6f6f6;
    .item{
        width: 100%;
        height: 710px;
        img{
            width: 100%;
            height: 100%;
        }
    }
}
</style>
